import { getPrerenderState } from './state';

/**
 * Synchronous reads of public API responses for the first render.
 * - Client: served from the state serialized in the HTML (until the route's page has mounted).
 * - Server (build): served from `serverApi.store`; unknown keys are recorded in `serverApi.misses` so the
 *   build script can fetch them and render again. Nothing is ever fetched during a render.
 */
export const apiKey = (url: string, params?: Record<string, unknown>): string => {
  const clean = url.replace(/^\/+/, '');
  const entries = Object.entries(params ?? {})
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .sort(([a], [b]) => a.localeCompare(b));
  if (entries.length === 0) return clean;
  return `${clean}?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
};

export const serverApi = {
  store: new Map<string, unknown>(),
  hits: new Set<string>(),
  misses: new Set<string>(),
  reset(): void {
    this.hits.clear();
    this.misses.clear();
  },
};

export const peekApi = <T,>(url: string, params?: Record<string, unknown>): T | undefined => {
  const key = apiKey(url, params);
  if (typeof window === 'undefined') {
    if (serverApi.store.has(key)) {
      serverApi.hits.add(key);
      return serverApi.store.get(key) as T;
    }
    serverApi.misses.add(key);
    return undefined;
  }
  const api = getPrerenderState()?.api;
  return api && key in api ? (api[key] as T) : undefined;
};
